import * as React from "react";
import { Button } from "../../shadcn/components/ui/Button";
import fund1 from "../../assets/home/fundraising/fund1.webp";
import fund2 from "../../assets/home/fundraising/fund2.webp";
import fund3 from "../../assets/home/fundraising/fund3.webp";
import { Link } from "react-router-dom";

export function Fundraising() {
  const funds = [
    {
      title: "Capital Improvement Funds",
      //description: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
     // goal: 450000,
      raised: 250000,
      progress: 56,
      image: fund1,
    },
    {
      title: "Special Needs Funds",
     // description: "iusto sint hic nemo amet",
      //goal: 750000,
      raised: 244024,
      progress: 33,
      image: fund2,
    },
    {
      title: "General Operating Funds",
      //description: "consectetur error odit dolorem?",
      //goal: 400000,
      raised: 62034,
      progress: 16,
      image: fund3,
    },
  ];

  return (
    <div className="py-8">
      <div className="flex items-center justify-center flex-col">
        <h2 className="text-center text-2xl lg:text-3xl text-purple-600 mb-2">
          Small acts, huge impact
        </h2>
        <h1 className="text-center normal-case text-xl lg:text-2xl font-bold text-purple-600 mb-2">
          Join us in our fundraising campaigns
        </h1>

        <p className="text-center text-purple-600 font-semibold lg:w-1/2 w-full mb-12 px-3">
         SilverTLC.com partners with 501C3 organizations servicing senior and disabled populaces with living 
and support services. Your giving will support those organizations based on your giving terms and 
territory.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-6 md:mb-2 mb-0">
        {funds.map((fund, index) => (
          <div
            key={index}
            className="w-80 bg-white rounded-lg shadow-lg overflow-hidden"
          >
            <img
              src={fund.image}
              alt={fund.title}
              className="w-full h-40 object-cover"
            />
            <div className="p-6">
              <h3 className="text-xl font-bold text-purple-600 mb-2">
                {fund.title}
              </h3>
             {/* <p className="text-gray-600 mb-4">{fund.description}</p>*/}
              <p className="font-bold mb-2">
              {/*  Goal: ${fund.goal.toLocaleString()}*/}
              </p>
              <div className="relative h-2 bg-gray-200 rounded-full mb-4">
                <div
                  className="absolute top-0 left-0 h-full bg-purple-600 rounded-full"
                  style={{ width: `${fund.progress}%` }}
                />
              </div>
              <div className="flex justify-between items-center">
                <Link to="/donate">
                  <Button className="bg-purple-600 text-white">
                    Donate Now
                  </Button>
                </Link>
                <span className="text-gray-600">
                  : ${fund.raised.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
